import { render, staticRenderFns } from "./AuthorizedIndividuals.vue?vue&type=template&id=30b821bc&scoped=true"
import script from "./AuthorizedIndividuals.vue?vue&type=script&lang=js"
export * from "./AuthorizedIndividuals.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedIndividuals.vue?vue&type=style&index=0&id=30b821bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b821bc",
  null
  
)

export default component.exports